module.exports = __webpack_public_path__ + "static/media/gary.61f63393.jpg";